<div class="scroll-view {{className}}" #scrollView [ngStyle]="{height: height}" (scroll)="onScroll($event)">
  <div class="full-contnet" #scrollContent>
    <ng-content></ng-content>
  </div>
</div>
